import { FC } from "react";
import { QESButton } from "./qes-standards"
import TooltipWrapper from "./TooltipWrapper";
import classNames from "classnames";

interface ButtonToggleProps {
  handleClick: (isPrimary: boolean) => void;
  hideTooltips?: boolean;
  isPrimarySelected: boolean;
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
  minWidth?: string;
  noWrap?: boolean;
  testId: string;
  disabled?: boolean;
  disabledText?: string;
  tooltipTextOneLine?: boolean;
}

export const ButtonToggle: FC<ButtonToggleProps> = (props: ButtonToggleProps) => {

  return (
    <div className="w-100">
      <div className={classNames({
        "button-toggle__container": true,
        "no-wrap": props.noWrap,
        "primary": props.isPrimarySelected,
        "secondary": !props.isPrimarySelected,
      })}
        style={{
          minWidth: props.minWidth,
        }}
      >
        <TooltipWrapper text={props.disabled && props.disabledText} triggerWidth="100%" containerClassName="d-flex w-100" oneLine={props.tooltipTextOneLine}>
          <TooltipWrapper text={!props.hideTooltips && !props.disabled && props.primaryButtonLabel} triggerWidth="100%" containerClassName="d-flex">
            <QESButton
              className="primary"
              qesType={props.disabled ? "disabled" : "none"}
              qesTestId={`button-toggle__primary--${props.testId}}`}
              onClick={() => { if (!props.disabled) props.handleClick(true) }}
              aria-pressed={props.isPrimarySelected}
              disabled={props.disabled}
            >
              {props.primaryButtonLabel}
            </QESButton>
          </TooltipWrapper>
          <TooltipWrapper text={!props.hideTooltips && !props.disabled && props.secondaryButtonLabel} triggerWidth="100%" containerClassName="d-flex">
            <QESButton
              className="secondary"
              qesType={props.disabled ? "disabled" : "none"}
              qesTestId={"button-toggle__secondary--${props.testId}"}
              onClick={() => { if (!props.disabled) props.handleClick(false) }}
              aria-pressed={!props.isPrimarySelected}
              disabled={props.disabled}
            >
              {props.secondaryButtonLabel}
            </QESButton>
          </TooltipWrapper>
        </TooltipWrapper>
      </div>
    </div>
  )
}